import React, { useEffect } from 'react';

const StructuredData: React.FC = () => {
  useEffect(() => {
    // Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Rokda Hisab",
      "alternateName": "RokdaHisab",
      "url": "https://rokadahisab.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://rokadahisab.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      },
      "description": "Free digital bahi khata and credit-debit ledger app for small businesses in India. Simple Gujarati hisab app for kirana shops and daily expense tracking."
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Rokda Hisab",
      "alternateName": "RokdaHisab",
      "url": "https://rokadahisab.com",
      "logo": "https://rokadahisab.com/og-image.png",
      "description": "Rokda Hisab - Best free digital bahi khata app for small business, kirana shop ledger, and daily expense tracking in Gujarat and India.",
      "sameAs": [
        "https://rokadahisab.com"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "availableLanguage": ["English", "Gujarati", "Hindi"]
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Small Business Owners, Shopkeepers, Kirana Stores, Gujarati Business Community"
      }
    };

    // SoftwareApplication/WebApp Schema
    const webAppSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Rokda Hisab App",
      "alternateName": "RokdaHisab - Digital Bahi Khata",
      "applicationCategory": "FinanceApplication",
      "operatingSystem": "Web Browser, Android, iOS",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "INR",
        "description": "Free digital bahi khata and ledger app"
      },
      "description": "Free Gujarati hisab book app for small business accounting, credit-debit ledger, udhar jama record, and daily expense tracking. Best digital bahi khata app for kirana shops in India.",
      "featureList": [
        "Digital Bahi Khata",
        "Credit-Debit Ledger",
        "Udhar Jama Record",
        "Daily Expense Tracker",
        "Gujarati Language Support",
        "Customer Reminders",
        "Business Reports",
        "Cashbook Management",
        "Free Forever"
      ],
      "screenshot": "https://rokadahisab.com/og-image.png",
      "softwareVersion": "1.0",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "1250",
        "bestRating": "5",
        "worstRating": "1"
      }
    };

    // Product Schema
    const productSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Rokda Hisab - Digital Bahi Khata App",
      "image": "https://rokadahisab.com/og-image.png",
      "description": "Free digital bahi khata and credit-debit ledger app for small businesses. Simple Gujarati hisab book app for kirana shops with udhar jama record and daily expense tracking.",
      "brand": {
        "@type": "Brand",
        "name": "Rokda Hisab"
      },
      "category": "Finance Software",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://rokadahisab.com/register"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      }
    };

    // FAQPage Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is Rokda Hisab app?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rokda Hisab is a free digital bahi khata and credit-debit ledger app designed for small businesses, kirana shops, and shopkeepers in India. It helps you maintain your business hisab book digitally with udhar jama record keeping and daily expense tracking in Gujarati language."
          }
        },
        {
          "@type": "Question",
          "name": "Is Rokda Hisab app free?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Rokda Hisab is completely free forever. It's the best free ledger app India for small businesses, kirana shops, and Gujarati vyapari. No hidden charges, no subscription fees."
          }
        },
        {
          "@type": "Question",
          "name": "Can I use Rokda Hisab for kirana shop ledger?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely! Rokda Hisab is specifically designed for kirana shop ledger management. It's a simple Gujarati hisab app perfect for small shops with features like customer udhar jama record, daily kharch tracking, and business accounting in Gujarati."
          }
        },
        {
          "@type": "Question",
          "name": "How to maintain udhar jama record in Rokda Hisab?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rokda Hisab makes it easy to maintain udhar jama record. Simply add customer credit-debit entries, and the app automatically tracks all udhar jama transactions. You can set reminders for pending payments and generate reports for your business hisab book."
          }
        },
        {
          "@type": "Question",
          "name": "Is there a Gujarati hisab book app available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Rokda Hisab is a fully Gujarati hisab book app designed for Gujarati vyapari and shopkeepers. It supports Gujarati language for all features including bahi khata, daily jama kharch tracking, and business accounting."
          }
        },
        {
          "@type": "Question",
          "name": "How to download free business hisab book mobile app?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rokda Hisab is a web-based app that works on any device - mobile, tablet, or computer. Simply visit rokadahisab.com and register for free. No download required. It's the best free business hisab book mobile app for daily jama kharch tracking."
          }
        },
        {
          "@type": "Question",
          "name": "Can I track daily expense in Gujarati?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Rokda Hisab is a daily expense tracker Gujarati app. You can track your daily jama kharch, business expenses, and income in Gujarati language. It's perfect for Gujarati vyapar hisab with complete daily jama kharch records."
          }
        },
        {
          "@type": "Question",
          "name": "Does the app send customer ledger reminders?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Rokda Hisab is a customer ledger app with reminders. You can set automatic reminders for pending udhar jama payments, helping you recover dues faster and maintain better business relationships."
          }
        },
        {
          "@type": "Question",
          "name": "What is the best digital bahi khata app for small shop?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Rokda Hisab is the best simple Gujarati hisab app for small shop owners. It offers digital bahi khata, credit-debit ledger, udhar jama record, and daily expense tracking - all in one free app designed specifically for Indian small businesses."
          }
        },
        {
          "@type": "Question",
          "name": "How to record udhar jama in digital bahi khata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Recording udhar jama in Rokda Hisab digital bahi khata is simple. Add customer name, enter credit amount, and the app automatically maintains your udhar jama record. You can track all pending payments, send reminders, and generate udhar jama reports anytime."
          }
        }
      ]
    };

    // Function to inject schema
    const injectSchema = (schema: object, id: string) => {
      // Remove existing schema with same ID if any
      const existing = document.getElementById(id);
      if (existing) {
        existing.remove();
      }

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    };

    // Inject all schemas
    injectSchema(websiteSchema, 'schema-website');
    injectSchema(organizationSchema, 'schema-organization');
    injectSchema(webAppSchema, 'schema-webapp');
    injectSchema(productSchema, 'schema-product');
    injectSchema(faqSchema, 'schema-faq');

    // Cleanup function
    return () => {
      ['schema-website', 'schema-organization', 'schema-webapp', 'schema-product', 'schema-faq'].forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.remove();
        }
      });
    };
  }, []);

  return null; // This component doesn't render anything
};

export default StructuredData;

